import React from 'react';
import img1 from "../../assets/ourteam/o1.png";
import img2 from "../../assets/ourteam/i1.jpeg";
import img3 from "../../assets/ourteam/i3.png";
import "./ourteam.css";

function Ourteam() {
    const teamMembers = [
        {
            img: img1,
            name: "Mr. Nazeer Ahmed Raheem",
            role: "Managing Director"
        },
        {
            img: img3,
            name: "Mr. Mohammed Rafeek",
            role: "Executive Director"
        },
        {
            img: img2,
            name: "Mr. Mohammed Iliyas",
            role: "Joint Director"
        }
    ];

    return (
        <div className='container'>
            <div className="section-title clearfix d-flex flex-column align-items-center">
                <div class="title-header">
                    <h5 style={{ textTransform: "uppercase", color: " #FFA800" }}>our board members</h5>
                    {/* <h3>New Sky Property & Projects Private Limited (NSPP)</h3> */}
                </div>
                <div className='underline'></div>
                <p>Our directors bring strong leadership, deep industry knowledge, and practical project experience that guide our company’s growth and reputation.</p>
            </div>


            <div className="team-wrapper">
                {teamMembers.map((member, index) => (
                    <div key={index} className="team-card">
                        <img src={member.img} alt={member.name} className="team-image" />
                        <div className="team-overlay">
                            <p className="team-text">
                                {member.name}
                                <b className="team-role">{member.role}</b>
                            </p>
                        </div>
                    </div>
                ))}
            </div>
            {/* <br></br> */}
            {/* <div>
                <p>Our Strength: Expert Team & Legal Support
At NSPP, we are proud to have a highly skilled team of real estate professionals, engineers, architects, and dedicated project managers who ensure every project is executed with quality, precision, and on-time delivery.</p>
                <p>We also work closely with top legal experts and senior advocates who specialize in property law. Our legal team has successfully handled many property-related cases, documentation clearances, and land dispute resolutions, ensuring all our projects and client dealings are legally strong and fully secured.</p>
                <p>Whether you are buying, selling, developing, or managing property, NSPP provides a seamless experience with full responsibility and care. Our mission is to build lasting relationships with every client by offering secure, quality-driven, and trustworthy real estate services.</p>
            </div> */}
        </div>
    );
}

export default Ourteam;
